import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddCategory from './components/AddCategory';
import '../../styles/products.scss';

const CategoryEdit = () => {
  const { id } = useParams();
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Modifier la Catégorie');
  }, [setTitle]);

  return (
    <div className="category-edit-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddCategory isEdit={true} categoryId={id} />
        </Col>
      </Row>
    </div>
  );
};

export default CategoryEdit;
